<template>
  <div >
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title>Driver Group Assignment</md-dialog-title>
        <div id="actionButton" style="margin-top: -50px; margin-left: 250px;">
            <md-button class="md-raised custButton" @click="cancelAction"><span clas="icons-center material-icons"></span>Cancel</md-button>
            <md-button id="create" class="md-raised custButton" @click="saveData"><span class="icons-center material-icons"></span>Assign</md-button>
            <!--<md-button id="create" class="md-raised custButton" @click="searchData"><span class="icons-center material-icons"></span>Search</md-button>-->
         </div> 
            <span style="width:100px; height:3px; display:''; background-color:'red'" id="undertab1"/>
            <span style="width:100px; height:3px; display:''" id="undertab2"/>
         <!--<md-progress-bar  id="pb" style="display:'none'" md-mode="indeterminate"/>-->           
         <div class="tab">
            <!--
            <md-button id="LoadOut" class="tablinks selected" @click="openTab('LoadOut')">Load Out</md-button>
            <md-button id="LoadIn" class="tablinks" @click="openTab('LoadIn')">Load In</md-button>
            -->
            <!--<md-button id="LoadIn" class="tablinks">Load In</md-button>-->
         </div>
    <!--       
       <nav>
    <ul>
      <li class="item"><a href="#">link 1</a></li>
      <li class="item"><a href="#">link 2</a></li>
      <li class="item"><a href="#">link 3</a></li>
      <li class="item"><a href="#">link 4</a></li>
      <li class="item"><a href="#">link 5</a></li>
    </ul>
  </nav>
  -->     
      <md-dialog-content >
        <div style="width: 600px; height: 300px">
         <form id="top" @submit.prevent="doSaveUser">
         <!--<md-progress-bar  id="pb" style="display:none" md-mode="indeterminate"/>-->
         <md-button type="submit" id="submit" style="display:none;" ></md-button> 
         <span class="info" id="status" style="display:none"></span>

         <auto-complete-stc-driver-group-select
                      label="Driver Group"
                      :options="stcDriverGroupOption"
                      v-model="driverGroup"
               >
         </auto-complete-stc-driver-group-select>

<!--         
         <div id="LoadOut" class="tabcontent" v-if="isLoadOut">
            <div class = "layout">
                <md-field>
                <label for="appointmentNoOut">Appointment No.</label>
                <md-input name="appointmentNoOut"
                        id="appointmentNoOut"
                        autocomplete="new-password"
                        v-model="dataForm.appointmentNoOut"
                />
                </md-field>
            </div>

            <div class = "layout">
                <auto-complete-master-data-select
                     group="LOADOUTTRANSTYPE"
                     label="Load Out Transaction Type"
                     display-type="nameOnly"
                     :init-value-id="this.dataForm.loadOutTransType"
                     :watch-value-id="this.dataForm.loadOutTransType"
                     :on-item-changed="handleloadOutTransTypeChanged"
                     :disabled="!this.allowLoadOutTrans"
                 >
                </auto-complete-master-data-select>
            </div>

            <div class = "layout">
              <datepicker v-model="dataForm.dateTimeSlotOut">
                <label>Appt Date</label>
              </datepicker>
            </div>

            <div class = "layout">
                <md-field>
                <label for="apptOutTime">Appt Time</label>
                <md-input name="apptOutTime"
                        id="apptOutTime"
                        autocomplete="new-password"
                        v-model="dataForm.apptOutTime"
                        placeholder="Format: HH:MM:SS"
                />
                <span class="md-error" v-if="!$v.dataForm.apptOutTime.add">
                   Appt time format is invalid!<br/>
                </span>
                </md-field>
            </div>

            <div class = "layout">
                <md-field>
                <label for="containerNo1">Container Number</label>
                <md-input name="containerNo1"
                        id="containerNo1"
                        autocomplete="new-password"
                        v-model="dataForm.containerNo1"
                />
                </md-field>
            </div>

            <div class = "layout">
                <auto-complete-master-data-select
                     group="LOAD_CTNRTYPE"
                     label="Order Item (Qty | Type | Appts)"
                     display-type="nameOnly"
                     :init-value-id="this.dataForm.orderItemOut"
                     :watch-value-id="this.dataForm.orderItemOut"
                     :on-item-changed="handleOrderItemOutChanged"
                >
                </auto-complete-master-data-select>
            </div>

            <div class = "layout">
                <md-field>
                <label for="pinNumber">Pin Number</label>
                <md-input name="pinNumber"
                        id="pinNumber"
                        autocomplete="new-password"
                        v-model="dataForm.pinNumber"
                />
                </md-field>
            </div>



            <div style="min-width:220px" v-if="drivers">
               <auto-complete-master-data-select
                  label="Driver Name"
                  display-type="idOnly"
                  :prepared-options="drivers"
                  :init-value-id="this.dataForm.driver"
                  :watch-value-id="this.dataForm.driver"
                  :on-item-changed="handleDriverChanged()"
                  :createOption = "false"
                  :reverse = "true"
                  >
               </auto-complete-master-data-select>
            </div>

            <div class = "layout">
                <md-field>
                <label for="driverMobile">Driver Mobile#</label>
                <md-input name="driverMobile"
                        id="driverMobile"
                        autocomplete="new-password"
                        v-model="dataForm.driverMobile"
                />
                </md-field>
            </div>

            <div class = "layout">
                <md-field>
                <label for="truckLic">Truck License</label>
                <md-input name="truckLic"
                        id="truckLic"
                        autocomplete="new-password"
                        v-model="dataForm.truckLic"
                />
                </md-field>
            </div>

            <div class = "layout">
                <md-field>
                <label for="pickup">Pickup</label>
                <md-input name="pickup"
                        id="pickup"
                        autocomplete="new-password"
                        v-model="dataForm.pickup"
                />
                </md-field>
            </div>

            <div class = "layout">
                <md-field>
                <label for="deliver">Deliver</label>
                <md-input name="deliver"
                        id="deliver"
                        autocomplete="new-password"
                        v-model="dataForm.deliver"
                />
                </md-field>
            </div>


            <div class = "layout">
               <md-checkbox v-model="loadInAllow" @change="loadInAllowChange">Add/Edit/Remove</md-checkbox>
            </div>   

            <div class = "layout">
                <auto-complete-master-data-select
                     group="LOAD_IN_TYPE"
                     label="Load In Type"
                     display-type="nameOnly"
                     :disabled="!this.loadInAllow"
                     :init-value-id="this.dataForm.loadStatusOut"
                     :watch-value-id="this.dataForm.loadStatusOut"
                     :on-item-changed="handleLoadStatusOutChanged"
                                                    >
                </auto-complete-master-data-select>
            </div>

            <div class = "layout">
                <md-field>
                <label for="containerNo2">Empty In Container Number</label>
                <md-input name="containerNo2"
                        id="containerNo2"
                        autocomplete="new-password"
                        v-model="dataForm.containerNo2"
                />
                </md-field>
            </div>

            <div class = "layout">
                <auto-complete-master-data-select
                     group="LOAD_CTNRTYPE"
                     label="Order Item (Qty | Type | Appts)"
                     display-type="nameOnly"
                     :init-value-id="this.dataForm.orderItemEmptyOut"
                     :watch-value-id="this.dataForm.orderItemEmptyOut"
                     :on-item-changed="handleOrderItemEmptyOutChanged"
                >
                </auto-complete-master-data-select>
            </div>

            <div class = "layout">
                <md-field>
                <label for="chassis">Chassis Number</label>
                <md-input name="chassis"
                        id="chassis"
                        autocomplete="new-password"
                        v-model="dataForm.chassisOut"
                />
                </md-field>
            </div>

        </div> 
-->
<!--
         <div id="LoadOut" class="tabcontent">
            <div class = "layout">
                <md-field>
                <label for="appointmentNoIn">Appointment No.</label>
                <md-input name="appointmentNoIn"
                        id="appointmentNoIn"
                        autocomplete="new-password"
                        v-model="dataForm.appointmentNoIn"
                />
                </md-field>
            </div>

            <div class = "layout">
                <auto-complete-master-data-select
                     group="LOADINTRANSTYPE"
                     label="Load In Transaction Type"
                     display-type="nameOnly"
                     :init-value-id="this.dataForm.loadInTransType"
                     :watch-value-id="this.dataForm.loadInTransType"
                     :on-item-changed="handleloadInTransTypeChanged"
                     :disabled="!this.allowLoadInTrans"
                 >
                </auto-complete-master-data-select>
            </div>

            <div class = "layout">
              <datepicker v-model="dataForm.dateTimeSlotIn">
                <label>Appt Date</label>
              </datepicker>
            </div>

            <div class = "layout">
                <md-field>
                <label for="apptInTime">Appt Time</label>
                <md-input name="apptInTime"
                        id="apptInTime"
                        autocomplete="new-password"
                        v-model="dataForm.apptInTime"
                        placeholder="Format: HH:MM:SS"
                />
                <span class="md-error" v-if="!$v.dataForm.apptInTime.add">
                   Load In Appt time format is invalid!
                 <br/></span>  
                </md-field>
            </div>

            <div class = "layout">
                <md-field>
                <label for="bknum">Booking Number</label>
                <md-input name="bknum"
                        id="bknum"
                        autocomplete="new-password"
                        v-model="dataForm.bknum"
                />
                </md-field>
            </div>

            <div class = "layout">
                <md-field>
                <label for="ctnrCount">Container Count</label>
                <md-input name="ctnrCount"
                        id="cntrCount"
                        autocomplete="new-password"
                        v-model="dataForm.ctnrCount"
                />
                </md-field>
            </div>

            <div class = "layout">
                <md-field>
                <label for="ctnrAssign">Container Assign</label>
                <md-input name="ctnrAssign"
                        id="ctnrAssign"
                        autocomplete="new-password"
                        v-model="dataForm.ctnrAssign"
                />
                </md-field>
            </div>

            <div class = "layout">
                <auto-complete-master-data-select
                     group="LOAD_CTNRTYPE"
                     label="Order Item Type"
                     display-type="nameOnly"
                     :init-value-id="this.dataForm.orderItemIn"
                     :watch-value-id="this.dataForm.orderItemIn"
                     :on-item-changed="handleOrderItemInChanged"
                 >
                </auto-complete-master-data-select>
            </div>

            <div class = "layout">
                <md-field>
                <label for="containerNoIn">Container Number</label>
                <md-input name="containerNoIn"
                        id="containerNoIn"
                        autocomplete="new-password"
                        v-model="dataForm.containerNoIn"
                />
                </md-field>
            </div>

            <div class = "layout">
                <md-field>
                <label for="sealIn">Seal Number</label>
                <md-input name="sealIn"
                        id="sealIn"
                        autocomplete="new-password"
                        v-model="dataForm.sealIn"
                />
                </md-field>
            </div>

            <div class = "layout">
                <md-field>
                <label for="chassisIn">Chassis Number</label>
                <md-input name="chassisIn"
                        id="chassisIn"
                        autocomplete="new-password"
                        v-model="dataForm.chassisIn"
                />
                </md-field>
            </div>
         -->           
<!--
            <div class = "layout">
               <md-checkbox v-model="loadOutAllow" @change="loadOutAllowChange">Add/Edit/Remove</md-checkbox>
            </div>   

            <div class = "layout">
                <auto-complete-master-data-select
                     group="LOAD_OUT_TYPE"
                     label="Load Out Type"
                     display-type="nameOnly"
                     :disabled="!this.loadOutAllow"
                     :init-value-id="this.dataForm.loadStatusIn"
                     :watch-value-id="this.dataForm.loadStatusIn"
                     :on-item-changed="handleLoadStatusInChanged"
                >
                </auto-complete-master-data-select>
            </div>
-->
<!--
            <div style="min-width:220px" v-if="drivers">
               <auto-complete-master-data-select
                  label="Driver Name"
                  display-type="idOnly"
                  :prepared-options="drivers"
                  :init-value-id="this.dataForm.driver"
                  :watch-value-id="this.dataForm.driver"
                  :on-item-changed="handleDriverChanged()"
                  :createOption = "false"
                  :reverse = "true"
                  >
               </auto-complete-master-data-select>
            </div>

            <div class = "layout">
                <md-field>
                <label for="driverMobile">Driver Mobile#</label>
                <md-input name="driverMobile"
                        id="driverMobile"
                        autocomplete="new-password"
                        v-model="dataForm.driverMobile"
                />
                </md-field>
            </div>

            <div class = "layout">
                <md-field>
                <label for="truckLic">Truck License</label>
                <md-input name="truckLic"
                        id="truckLic"
                        autocomplete="new-password"
                        v-model="dataForm.truckLic"
                />
                </md-field>
            </div>

            <div class = "layout">
            -->
            <!--   
                <md-field>
                <label for="deliver">Deliver</label>
                <md-input name="deliver"
                        id="deliver"
                        autocomplete="new-password"
                        v-model="dataForm.deliver"
                />
                </md-field>
            -->
            <!--
                <auto-complete-master-data-select
                     group="DELIVER_LOC"
                     label="Deliver"
                     display-type="nameOnly"
                     :init-value-id="this.dataForm.deliver"
                     :watch-value-id="this.dataForm.deliver"
                     :on-item-changed="handleDeliverChanged"
                 >
                </auto-complete-master-data-select>

            </div>

            <div class="text-divider">Empty Out</div>

            <div class = "layout">
                <md-field>
                <label for="emptyOutBk">Empty Out Booking Number</label>
                <md-input name="emptyOutBk"
                        id="emptyOutBk"
                        autocomplete="new-password"
                        v-model="dataForm.emptyOutBk"
                />
                </md-field>
            </div>

            <div class = "layout">
            -->
            <!--    <md-field>
                <label for="emptyOutCarrier">Empty Out BK Carrier</label>
                <md-input name="emptyOutCarrier"
                        id="emptyOutCarrier"
                        autocomplete="new-password"
                        v-model="dataForm.emptyOutCarrier"
                />
                </md-field>
            -->  
           <!--   
                <auto-complete-master-data-select
                     group="STC_CARRIER"
                     label="Empty Out BK Carrier"
                     display-type="nameOnly"
                     :init-value-id="this.dataForm.emptyOutCarrier"
                     :watch-value-id="this.dataForm.emptyOutCarrier"
                     :on-item-changed="handleCarrierChanged"
                 >
                </auto-complete-master-data-select>
            </div>

            <div class = "layout">
               <md-field>
                  <label for="note">Note</label>
                  <md-input name="note"
                     id="note"
                     autocomplete="new-password"
                     v-model="dataForm.note"
               />      
               </md-field>   
            </div>   
         


        </div> 
      -->
        </form>  
       </div> 
       
      </md-dialog-content>
    </md-dialog>
  </div>
</template>


<style scoped>
.alwaysShow {
  position: fixed;
  right: 60px;
  top : 30px;
}

.icons-center {
    vertical-align: middle;
    margin-right: 10px;
}

.custButton {
    margin: 10px;
    width: 120px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
   
}

.heading{
      padding-top: 10px;
     margin-bottom: 0;
      color: #555555;
      width: 92%;
      line-height: 3;
      font-size: 40px;
      font-family: Roboto Slab;
      margin-left: 44px;
}

  .layout{
      padding-top: 7px;
      padding-bottom: 7px;
      width: 92%;
      line-height: 1.5;
      color: #555555;
      font-family: Roboto Slab;
      margin: auto;
  }

  .tab {
      overflow: hidden;
      border: 1px solid #ccc;
      background-color: #f1f1f1;
  }

  .tab button {
      background-color: inherit;
      float: left;
      border: none;
      outline: none;
      cursor: pointer;
      padding: 14px 16px;
      transition: 0.3s;
      /*font-size: 17px;*/
  }

  .tablinks {
     height: 50px;
  }

  .tab button:hover {
      background-color:#ddd;
      text-decoration: underline;
  }

  .tab button:active, button:focus {
      background-color: #ccc;
      text-decoration: underline;
  }

  
  .tabcontent {
      /*display: none;*/
      padding: 6px 12px;
      border: 1px solid #ccc;
      border-top: none;
  }

.info {
    background-color: #2196f3;
    display: inline-block;
    font-size: 18px;
    font-weight: 600;
    color: white;
    padding: 8px;
    height: 30px;
  }

  .result-included-outter-div {
    border: 1px solid #D0D0D0;
    border-radius: 5px;
    width: 600px;
    padding: 10px;
    height: 43px;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 100px;
   }

.result-included-inner-div {
    margin-left: 15px;
    font-weight: bold;
    /*margin-bottom: -25px;*/
    margin-top: 5px;
} 

.selected {
   text-decoration: underline;
   font-size: 14px;
   font-weight: 500;
}    

.text-divider {
  display: flex;
  align-items: center;
  --text-divider-gap: 1rem;
  font-weight:bold;
}

.text-divider::before,
.text-divider::after {
  content: '';
  height: 1px;
  background-color: silver;
  flex-grow: 1;
}

.text-divider::before {
  margin-right: var(--text-divider-gap);
}

.text-divider::after {
  margin-left: var(--text-divider-gap);
}


</style>


<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import { minLength, required , maxLength} from 'vuelidate/lib/validators';
  import callingApiCenter from "./CallingApiCenter.vue";
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';
  import AutoCompleteStcDriverGroupSelect from '../components/AutoCompleteStcDriverGroupSelect.vue';
  import dateFormat from '../utils/dateFormat';

//    const getInitialdataForm = () => ({
//       loadKey: null,
//       appointmentNoIn: null,
//       transType: null,
//       dateTimeSlotOut: null,
//       apptOutTime: null,
//       containerNo1: null,
//       containerNo2: null,
//       sealOut: null,
//       chassisIn: null,
//       chassisOut: null,
//       truckLic: null,
//       driver: null,
//       driverMobile: null,
//       pickup: null,
//       deliver: null,
//       pinNumber: null,
//       loadStatusOut: null,
//       loadStatusIn: null,
//       cntrTypeOut1: null,
//       cntrTypeOut2: null,
//       cntrTypeIn: null,
//       emptyOutBk: null,
//       emptyOutCarrier: null,
//       bknum: null,
//       ctnrCount: null,
//       ctnrAssign: null,
//       carrier: null,
//       orderItemOut: null,
//       orderItemEmptyOut: null,
//       appointmentNoIn: null,
//       dateTimeSlotIn: null,
//       apptInTime: null,
//       containerNoIn: null,
//       sealIn: null,
//       orderNo: null,
//       orderItemIn: null,
//       note: null,
//       loadInTransType: null,
//       loadOutTransType: null,
//       message: null,
//      status: null,
//      inStartTime: null,
//      sendDate: null,
//      selectedTransType: null,
//    });

//   const getInitialMsg = () => ({
//      driver: null,
//      truckLic: null,
//      deliver: null,
//      bknum: null,
//      carrier: null,
//      containerNoIn: null,
//      cntrTypeIn: null,
//      sealIn: null,
//      loadStatusIn: null,
//      emptyOutBk: null,
//      note: null,
//   });


//   const getInitialSendSMSInfo = () => ({
//     loadKey: null, 
//     index: null,
//     shortId: null,
//     driverMobile: null,
//     //inboundShipment: null,
//     containerNo: null,
//     message: null,
//     messageId: null,
//     status: null,
//     sendDate: null,
//   });

// //  const getInitialStatusForm = () => ({
// //    messageId: null,
// //    status: null,
// //    inStartTime: null,
// //  });

//   const getInitialSMSLog = () => ({
//       loadKey: null,
//       driverMoible: null,
//       shortId: null,
//       //inboundShipment: null,
//       //containerNo: null,
//       message: null,
//       status: null,
//       sendDate: null,
//       messageId: null,
//       createdAt: null,
//       createdBy: null,
//       updatedAt: null,
//       updatedBy: null,
//     });
  const initSearchDriverGroup = () => ({
     seqNo: null,
     driverGroup: null,
     userName: null,
     driverId: null,
     active: true,
     driverName: null,
     recWindow: null
  })

//   const getInitialLoadInForm = () => ({
//       appointmentNoIn: null,
//       transType: null,
//       dateTimeSlotIn: null,
//       containerNo1: null,
//       containerNo2: null,
//       sealIn: null,
//       truckLic: null,
//       driver: null,
//       location: null,
//       loadStatus: null,
//       bknum: null,
//       orderItem: null,
//       message: null,
//       status: null,
//       sendDate: null,
//       messageId: null,
//       createdAt: null,
//       createdBy: null,
//       updatedAt: null,
//       updatedBy: null,
//   });  

//   const getInitialLoadOutForm = () => ({
//       appointmentNoOut: null,
//       transType: null,
//       dateTimeSlotOut: null,
//       containerNoOut: null,
//       sealOut: null,
//       orderNo: null,
//       orderItem: null,
//       message: null,
//       status: null,
//       sendDate: null,
//       messageId: null,
//       createdAt: null,
//       createdBy: null,
//       updatedAt: null,
//       updatedBy: null,
//   });  


  export default {
    components: { 
      callingApiCenter,       
      AutoCompleteStcDriverGroupSelect
    },
    mixins: [validationMixin],
    props: {
      mode: String,
      //onCreate: Function,
      onUpdate: Function,
    },
    data: () => ({
      showDialog: false,
      //dataForm: getInitialdataForm(),
      //statusForm: getInitialStatusForm(),
      //smslogForm: getInitialSMSLog(),
      //sendSMSInfo: getInitialSendSMSInfo(),
      //sendMsg: getInitialMsg(),
      searchDriverGroupReq: initSearchDriverGroup(),
      //items: [],
      //selected:null,
      drivers: [],
      //isSMS: true,
      //showbar: false,
      //isShowLog: false,
      //isShowSMS: false,
      //isShowSMSOutbound: false,
      //isShowLogOutbound: false,
      //isdisableSend: false,
      //isSend: false,
      //isRefresh: false,
      //smsLog: [],
      //smslist: [],
      //sendSMSList: [],
      //getLog: [],
      //requestdatabackup: null,
      //reload: true,
      //radio: false,
      //isLoadIn: false,
      //isLoadOut: true,
      //loadInAllow: false,
      //loadOutAllow: false,
      //allowLoadInTrans: true,
      //allowLoadOutTrans: true,
      //msgSend: null,
      input_mode: null,
      driverGroup: null,
      stcDriverGroupOption: []
    }),

    computed: {
      ...mapGetters([
        'getMasterDataByGroup',
        'getMasterDataName',
        'getUserProfile',
        'getGSTDriverMaster',
        'getGSTDriverTruckLog',
      callingApiCenter,
      ]),
   //    getGSTDriverTruckLog() {
   //      console.log("getGSTDriverTrucklog:");
   //    },  
   //  filteredRows(){
   //      return this.items.filter(row => {
   //        const term = this.filter.toUpperCase();
   //        return this.includeNull(null).includes(term)
   //      })
   //    },

   //    getSelectedItems() {
   //      return _(this.items)
   //        .filter(it => it.selected);
   //    },

   //    getEditingItems() {
   //      return _(this.items)
   //        .filter(it => it.editing);
   //    },

   //    canEdit() {
   //      return this.getSelectedItems.length === 1 ;
   //    },

   //    getSMSLog(){
   //      return _(this.smsLog)
   //      .sortBy(it => it.inboundShipment); 
   //    },

   //    loadSendList(){
   //      var indx = 0;
   //      // while (this.smslist.length >= indx && this.smslist.length > -1)
   //      // {
   //      //    this.smslist[indx].index = indx;
   //      //    indx += 1;
   //      // }
   //      if (this.smslist.length > -1)
   //      {
   //         this.smslist.forEach( (it) => {
   //            it.index = indx;
   //            indx += 1;
   //         });
   //      }
   //      return _(this.smslist)
   //      .sortBy(it => it.inboundShipment);
   //    },

   //    getLogWithSource() {
   //       console.log("getLogWithSource");
   //       alert("radio value: " + this.radio);
   //    },



    },


    async mounted() {
      // const alldrivers = await this.$store.dispatch(
      //     'getDriversBySource',
      //     {
      //       defaultSalesOffice: 'LGB',
      //       source: 'OUTBOUND',
      //     }
      // );
      // console.log("alldrivers: " + JSON.stringify(alldrivers));
      // this.drivers = alldrivers;
      //await api.post('/api/w/stc/WebSearchDriverGroup', this.searchDriverGroupReq).then((driverGroup) => {
      await newAPIPost('/api/w/stc/WebSearchDriverGroup', this.searchDriverGroupReq).then((driverGroup) => {
          this.stcDriverGroups = driverGroup;
      })

      //console.log("stc driver groups: " + JSON.stringify(allSTCDriverGroups)); 
      //console.log("stc driver groups: " + this.getSTCDriverGroup); 
      console.log("stc driver groups: " + JSON.stringify(this.stcDriverGroups))
      //const allSTCDriverGroups = this.getSTCDriverGroup;
      if (this.stcDriverGroups) {
        this.stcDriverGroups.forEach( (val) => {
            const p_driverGrp = this.stcDriverGroupOption.filter( it => it === val.driverGroup);
            console.log("p_driverGrp length: " + p_driverGrp.length);
            if (p_driverGrp.length == 0)
               this.stcDriverGroupOption.push(val.driverGroup);
          }
        )
          
      }      
    },

    watch: {
      // getGSTDriverMaster(val) {
      //   this.updateItems(val);
      // },
      // getGSTDriverTruckLog(val) {
      //   console.log("watch method");
      //   this.updateItems(val);
      // }
    },


    validations: {
      // dataForm: {
      //     driver: {required},
      //     driverMobile: {required},
      //   apptInTime:{
      //       add : (value) => {
              
      //         const res = moment('2021-04-01T' + value).toDate();
      //         return res != 'Invalid Date';
      //       }
      //   },
      //   apptOutTime:{
      //       add : (value) => {
              
      //         const res = moment('2021-04-01T' + value).toDate();
      //         return res != 'Invalid Date';
      //       }
      //   },
      // },
    },



    methods: {
      async openDialog(requestdata) {
        this.$store.commit('clearApiError');
        //this.$v.dataForm.$reset();
        //console.log(this.$v.dataForm.$invalid);
        //this.dataForm = getInitialdataForm();
        console.log("update form: " + this.mode);
        console.log("request data: " + requestdata);
        console.log("mode: " + this.mode);

      //   await api.post('/api/w/gstMasterData/driverMasterData', this.searchDriverSearchReq)
      //            .then ( (driverinfo) => {
      //               if (driverinfo) {
      //                   driverinfo.forEach( (it) => {
      //                       console.log("driver: " + it.shortId);
      //                       this.drivers.push(it.shortId + "(" + it.driverId + ")");
      //                       //this.driverIds.push(it.driverId);
      //                       //this.driverNames.push(it.userName);
      //                       //this.driverContent.push(it.shortId + "(" + it.driverId + ")");
      //                   })
      //               }
      //            });
      //     console.log("drivers: [[" + this.drivers + "]]");

        this.showDialog = true;
      },

      // updateItems(itemsSource) {
      //     console.log("itemsSource: " + itemsSource);
      //     var items = JSON.parse(JSON.stringify(itemsSource));
      //     items.forEach((it) => {
      //       it.backGroud = false;
      //       it.selected = false;
      //       it.editing = false;
      //     });
      //     console.log("items:" + items);
      //     this.items = items;
      // },

      // handleScroll(e) {
      //       $(this.$el.querySelector('.table-header'))
      //       .offset({
      //           left: -1 * (e.target.scrollLeft - $('.outer-container')
      //           .offset().left),
      //       });
      // },


      // getValidationClass(fieldName) {
      //   const field = _(this.$v)
      //     .lookup(fieldName);
      //   if (field) {
      //     return {
      //       'md-invalid': field.$invalid && field.$dirty,
      //     };
      //   }
      //   return {};
      // },


      // handleSalesOfficeChanged(id){
      //     console.log('saleoffice id:' + id );
      //     this.dataForm.defaultSalesOffice = id;
      // },

      // handleLoadStatusInChanged(id){
      //     console.log('load status In:' + id );
      //     this.dataForm.loadStatusIn = id;
      // },

      // handleLoadStatusOutChanged(id){
      //     console.log('load status Out:' + id );
      //     this.dataForm.loadStatusOut = id;
      // },

      // handleOrderItemInChanged(name){
      //     console.log('order item In:' + name );
      //     this.dataForm.orderItemIn = name;
      // },

      // handleDeliverChanged(name){
      //     console.log('deliver:' + name );
      //     this.dataForm.deliver = name;
      // },

      // handleCarrierChanged(name){
      //     console.log('carrier:' + name );
      //     this.dataForm.emptyOutCarrier = name;
      // },

      // handleOrderItemOutChanged(name){
      //     console.log('order item Out:' + name );
      //     this.dataForm.orderItemOut = name;
      //     this.getCntrType(name,1);
      //     console.log("cntr type item out: " + this.dataForm.cntrTypeOut1);
      // },

      // handleOrderItemEmptyOutChanged(name){
      //     console.log('order item Empty Out:' + name );
      //     this.dataForm.orderItemEmptyOut = name;
      //     this.getCntrType(name,2);
      //     console.log("ctrn type empty out: " + this.dataForm.cntrTypeOut2);
      // },

      // handleloadInTransTypeChanged(name){
      //     console.log('load In Trans Type:' + name );
      //     this.dataForm.loadInTransType = name;
      //     this.dataForm.selectedTransType = name;
      //     if (name == null || name == "")
      //        this.allowLoadOutTrans = true;
      //     else   
      //        this.allowLoadOutTrans = false;
      // },

      // handleloadOutTransTypeChanged(name){
      //     console.log('load Out Trans Type:' + name );
      //     this.dataForm.loadOutTransType = name;
      //     this.dataForm.selectedTransType = name;
      //     if (name == null || name == "")
      //        this.allowLoadInTrans = true;
      //     else   
      //        this.allowLoadInTrans = false;
      // },

      // handleDriverTypeChanged(id){
      //     console.log('Driver Type id:' + id );
      //     this.dataForm.driverType = id;
      // },

      // handleDriverStatusChanged(id){
      //     console.log('Driver Status id:' + id );
      //     this.dataForm.driverStatus = id;
      // },

      // handleDriverStateChanged(id){
      //     console.log('Driver State id:' + id);
      //     this.dataForm.driverState = id;
      // },

      // getCntrType(selectedItem,loadoutcntr)
      // {
      //     console.log("selectedItem: " + selectedItem + " loadoutcntr: " + loadoutcntr);
      //     //this.dataForm.cntrTypeOut1 = "";
      //     //this.dataForm.cntrTypeOut2 = "";
      //     //if (selectedItem.includes("40’High-Cube") || selectedItem == 11)
      //     if (selectedItem === "11")
      //      if (loadoutcntr === 1)
      //        this.dataForm.cntrTypeOut1 = "40HC";
      //      else
      //        this.dataForm.cntrTypeOut2 = "40HC";  
      //     //if (selectedItem.includes(" 40’Flex (STD or HQ)") || selectedItem == 12)
      //     if (selectedItem === "12")
      //      if (loadoutcntr === 1)
      //        this.dataForm.cntrTypeOut1 = "40STD/HQ";
      //      else
      //        this.dataForm.cntrTypeOut2 = "40STD/HQ";  
      //     //if (selectedItem.includes("40’Standard") || selectedItem == 13)
      //     if (selectedItem === "13")
      //      if (loadoutcntr === 1) 
      //        this.dataForm.cntrTypeOut1 = "40STD";
      //      else
      //        this.dataForm.cntrTypeOut2 = "40STD"; 
      //     //if (selectedItem.includes("20’Standard") || selectedItem == 14)
      //     if (selectedItem === "14")
      //      if (loadoutcntr === 1)
      //        this.dataForm.cntrTypeOut1 = "20STD";  
      //      else
      //        this.dataForm.cntrTypeOut2 = "20STD";   
      //     console.log("cntyTypeOut: " + this.dataForm.cntrTypeOut1);
      //     console.log("cntyTypeOut: " + this.dataForm.cntrTypeOut2);
      // },

      // handleDriverChanged() {
      //   return (id, name, unit, weight, plate, trail) => {
      //     //console.log("itsm driverPh: " + item.driverPh);
      //     //item.driverPh = "";
      //     //console.log(`Item is ${item}`)
      //     //item.moveInBy = id;
      //     //item.driverPh = name;
      //     this.dataForm.driver = id;
      //     this.dataForm.driverMobile = name;
      //     this.dataForm.truckLic = plate;
      //     //console.log(`Phone is ${item.driverPh}`);
      //     //item.message = "3555";
      //     //this.$forceUpdate()
      //     console.log("selected Items driverPh: " + name);
      //     //console.log("selected Items driverPh: " + item.driverPh);
      //     //console.log("selected item index: " + item.index);
      //     //if (item.index > -1)
      //     //{
      //     //    console.log("selected item driverPh: " + this.smslist[item.index].driverPh);
      //     //}
      //     //if (document.getElementById("smsoutbound"))
      //     //{
      //     //   console.log("find smsoutbound element");
      //     //   document.getElementById("smsoutbound").refresh;
      //    // }
      //   };
      // },

      // loadInAllowChange() {
      //   console.log("load in checkbox change: " + this.loadInAllow);
      // },

      // loadOutAllowChange() {
      //   console.log("load out checkbox change: " + this.loadOutAllow);
      // },

      // handleCreationDriver()
      //  {},

      // includeNull(field){
      //           return field==null ? '' : field;
      //       },



     cancelAction(){
        this.isdisableSend = false;
        this.isRefresh = false;
        this.showDialog = false;
        this.allowLoadInTrans = true;
        this.allowLoadOutTrans = true;
        this.smslog = [];
        this.$store.commit('clearApiError');
     },

     saveData(){

      this.onUpdate(this.driverGroup, this.input_mode);
      this.showDialog = false;
   },

   //   searchData()
   //   {
   //      console.log("searchData");
   //   },

   //   getMessage(transtype)
   //   {
   //      var smsmessage = "";
   //      var commonmsg = "";
   //      var loadintype = "";
   //      var loadouttype = "";
   //      var optmsg = "";

   //      if (this.dataForm.cntrTypeIn == null && this.dataForm.orderItemIn != null)
   //      {
   //         if (this.dataForm.orderItemIn == "11")
   //         {
   //            this.dataForm.cntrTypeIn = "40HC";
   //         }
   //         if (this.dataForm.orderItemIn == "12")
   //         {
   //            this.dataForm.cntrTypeIn = "40STD/HQ";
   //         }
   //         if (this.dataForm.orderItemIn == "13")
   //         {
   //            this.dataForm.cntrTypeIn = "40STD";
   //         }
   //         if (this.dataForm.orderItemIn == "14")
   //         {
   //            this.dataForm.cntrTypeIn = "20STD";
   //         }
   //      }

   //      console.log("getmessage transtype: " + transtype);
   //      if (transtype === "loadinemptyout")
   //      {
   //         loadintype = "Load In";
   //         loadouttype = "Empty Out"
   //         optmsg = loadouttype + "\n";
   //         optmsg += "Bkg#:" + this.dataForm.emptyOutBk + "(" + this.dataForm.emptyOutCarrier + ")\n";
   //      }
   //      if (transtype === "loadinloadout")
   //      {
   //         loadintype = "Load In";
   //         loadouttype = "Load Out";
   //         optmsg = loadouttype + "\n";
   //         optmsg += "Pin:" + this.dataForm.pinNumber + "\n"
   //         optmsg += this.dataForm.containerNo1 + "\n";
   //      }
   //      if (transtype === "loadinonly")
   //      {
   //         loadintype = "Load In";
   //         optmsg = "";
   //      }

   //      if (transtype === "loadinemptyout" || transtype === "loadinloadout" || transtype === "loadinonly")
   //      {
   //         commonmsg = "ApptNo:" + this.dataForm.appointmentNoIn + "\n";
   //         commonmsg += "Appt:" + moment(this.dataForm.dateTimeSlotIn,"MM-DD-YYYY").format('LL') + " " + this.dataForm.apptInTime + "\n";
   //         commonmsg += this.dataForm.driver + "(" + this.dataForm.truckLic + ")\n";
   //      }
   //      else
   //      {
   //         commonmsg = this.dataForm.driver + "(" + this.dataForm.truckLic + ")\n";
   //      }   
   //      commonmsg += "Port:" + this.dataForm.deliver + "\n";
   //      commonmsg += loadintype + "\n";
   //      commonmsg += "Bkg#:" + this.dataForm.bknum + "(" + this.dataForm.carrier + ")\n";
   //      commonmsg += this.dataForm.containerNoIn + "(" + this.dataForm.cntrTypeIn + ")\n";
   //      commonmsg += this.dataForm.chassisIn + "\n";
   //      if (transtype === "loadinemptyout" || transtype === "loadinloadout" || transtype === "loadinonly")
   //         smsmessage = commonmsg + optmsg + this.dataForm.note;
   //      if (transtype === "emptyInloadout")
   //      {
   //         smsmessage = "Empty In\n";
   //         smsmessage += "Driver:" + this.dataForm.driver + "\n";
   //         smsmessage += "Port:" + this.dataForm.deliver + "\n";
   //         smsmessage += this.dataForm.containerNoIn + "(" + this.dataForm.cntrTypeIn + ")\n";
   //         smsmessage += this.dataForm.chassisOut + "\nLoad Out\n";
   //         smsmessage += this.dataForm.containerNo1 + "(" + this.dataForm.cntrTypeOut1 + ")\n";
   //         smsmessage += this.dataForm.pinNumber + "\n";
   //         smsmessage += this.dataForm.note;
   //      }   
   //      if (transtype === "loadoutonly")
   //      {
   //         smsmessage = "Load Out\n";
   //         smsmessage += "Driver:" + this.dataForm.driver + "\n";
   //         smsmessage += "Port:" + this.dataForm.deliver + "\n";
   //         smsmessage += "Pin#" + this.dataForm.pinNumber + "\n";
   //         smsmessage += "Container#" + this.dataForm.containerNo1 + "\n";
   //         if (this.dataForm.note != null)
   //            smsmessage += this.dataForm.note;
   //      }
   //      return smsmessage;
   //   },

   //   async refreshAction(){
   //      // const req = this.requestdatabackup;
   //      // this.getInitialSMSLog();
   //      // if (req != null && req.length > 0)
   //      // {
   //      //    req.forEach( (it) => {
   //      //        this.smslogForm.inbound
   //      //    }

   //      //    )
   //      // }
   //      // console.log("inboundshipment: " + this.dataForm.inboundShipment);
   //      if (document.getElementById("pb"))
   //      {
   //         document.getElementById("pb").style.display = "";
   //      }
   //      const refreshLog = api.post('/api/w/SendSMS/RefreshLog', {smsInfo: this.getLog})
   //      .then((it) => {
   //        console.log("messageId: " + it[0].messageId);
   //        this.smsLog = it;
   //        if (document.getElementById("pb"))
   //        { 
   //           document.getElementById("pb").style.display = "none";
   //        }
   //      }
   //      )
   //   },

   //   doSaveUser() {
   //     console.log("doSaveUser");
   //   },

/*
      async doSaveUser() {
        this.isMain = true;
        this.isDriver = false;
        this.isArea = false;
        this.$v.dataForm.$touch();
        if (this.$v.dataForm.$invalid) {
          return;
        }

        const req = this.dataForm;
       await  api.post("/api/w/gstMasterData/updateDriver", req)
          .then(() => {
            this.$store.commit('clearApiError');
            this.showDialog = false;
            console.log("apptNo: " + this.dataForm.apptNo);
            this.onCreate(this.dataForm.shortId, this.dataForm.driverMobile, this.dataForm.defaultPlateNum, this.dataForm.trailernum, this.dataForm.apptNo);
            //this.onCreate(this.dataForm.shortId, this.dataForm.driverMobile, this.dataForm.defaultPlateNum, this.dataForm.apptNo);
            $('.btn-search-master-form-driver')
              .click();
            
          });
      },
*/

//       openTab(tabname) {
//          /*
//          var i, tabcontent, tablinks;

//          // Get all elements with class="tabcontent" and hide them
//          tabcontent = document.getElementsByClassName("tabcontent");
//          for (i = 0; i < tabcontent.length; i++) {
//               tabcontent[i].style.display = "none";
//          }

//          // Get all elements with class="tablinks" and remove the class "active"
//          tablinks = document.getElementsByClassName("tablinks");
//          for (i = 0; i < tablinks.length; i++) {
//              tablinks[i].className = tablinks[i].className.replace(" active", "");
//          }

//          // Show the current tab, and add an "active" class to the button that opened the tab
//          document.getElementById(tabname).style.display = "block";
//          evt.currentTarget.className += " active";   
//         */
//          console.log("tabname: " + tabname);
//          var i, tabcontent, tablinks;
         
//          if (tabname === "LoadIn")
//          {
//             this.isLoadIn = true;
//             this.isLoadOut = false;
//             this.dataForm.transType = "Load In";
//             if (document.getElementById("LoadIn"))
//             {
//                document.getElementById("LoadIn").className = "tablinks selected"
//             }
//             if (document.getElementById("LoadOut"))
//             {
//                document.getElementById("LoadOut").className = "tablinks"
//             }
//          }

//          if (tabname === "LoadOut")
//          {
//             this.isLoadIn = false;
//             this.isLoadOut = true;
//             this.dataForm.transType = "Load Out";
//             if (document.getElementById("LoadIn"))
//             {
//                document.getElementById("LoadIn").className = "tablinks"
//             }
//             if (document.getElementById("LoadOut"))
//             {
//                document.getElementById("LoadOut").className = "tablinks selected"
//             }
//          }
// /*
//          tabcontent = document.getElementsByClassName("tabcontent");
//          for (i = 0; i < tabcontent.length; i++)
//          {
//             tabcontent[i].style.display = "none";
//          }
//          tablinks = document.getElementsByClassName("tablinks");
//          for (i = 0; i < tablinks.length; i++)
//          {
//             tablinks[i].className = tablinks[i].className.replace(" active",""); 
//          }
//          //document.getElementById(tabname).style.display = "block";
//          //evt.currentTarget.className += " active";
//          document.getElementById(tabname).className += " active";
//   */
//      },

//       async sendSMS() {
//          console.log("in sendSMS - driver name: " + this.dataForm.shortId);
//          console.log("in sendSMS - driver mobile: " + this.dataForm.driverMobile);
//          console.log("in sendSMS - inbound shipment: " + this.dataForm.inboundShipment);
//          console.log("in sendSMS - message: " + this.dataForm.message);
//          var indx = 0;
         
//          this.isdisableSend = true;
//          //const req1 = this.dataForm;
//          //var sendInfo = this.getInitialSendSMSInfo();
//          //const req1 = this.statusForm;
//          //req1.driverMobile = "+1" + req1.driverMobile;
//          //req1.driverMobile = "+19097849755";
//          //req1.driverMobile = "+19095695793";
//          //req1.driverMobile = "+19094735544";
//          //req1.messageId = "8d2bc293-fe4e-5b93-9235-9bca4a968a38";
//          //req1.inStartTime = "2021/07/02 10:00:00";
//          while (this.sendSMSList.length > 0) { this.sendSMSList.pop();}
//          console.log("smslist length: " + this.smslist.length);
//          console.log("smslist 1st inboundShipment: " + this.smslist[0].inboundShipment);
//          //console.log("smslist 2nd inboundShipment: " + this.smslist[1].inboundShipment);
//          this.smslist.forEach( (it) => {
//             this.sendSMSInfo.index = indx;
//             if (this.mode === "SMS" || this.mode === "CALLSMS")
//             {
//                this.sendSMSInfo.inboundShipment = it.inboundShipment;
//             }
//             else
//             {   
//                if (this.mode === "SMSOUTBOUND")
//                {
//                   this.sendSMSInfo.inboundShipment = it.containerNo;
//                }
//                else
//                {
//                   if (this.mode === "STCSMSOUTBOUND")
//                   {
//                      this.sendSMSInfo.inboundShipment = it.containerNo;
//                      this.sendSMSInfo.containerNo = it.containerNo;
//                   }
//                   else
//                      this.sendSMSInfo.inboundShipment = "";
//                }
//             }
//             this.sendSMSInfo.loadKey = it.seqNo;
//             this.sendSMSInfo.shortId = this.dataForm.driver;
//             this.sendSMSInfo.driverMobile = "+1" + this.dataForm.driverMobile;
//             //this.sendSMSInfo.driverMobile = "+19095695793";
//             this.sendSMSInfo.message = this.dataForm.message;
//             this.sendSMSInfo.status = "";
//             this.sendSMSInfo.sendDate = "";
//             this.sendSMSInfo.messageId = "";
//             console.log("send loop phone number: " + this.dataForm.driver);
//             console.log("send loop phone number: " + this.sendSMSInfo.driverMobile);
//             //console.log("send loop ibs: " + this.sendSMSInfo.inboundShipment);
//             console.log("send loop container no: " + this.sendSMSInfo.containerNo);
//             console.log("send loop loadKey: " + this.sendSMSInfo.loadKey);
//             console.log("send loop index: " + it.index);
//             this.sendSMSList.push(this.sendSMSInfo);
//             this.sendSMSInfo = getInitialSendSMSInfo();
//             indx += 1;
//          });
//          console.log("sendSMSList length: " + this.sendSMSList.length);
//          console.log("sendSMSList 1st loadKey: " + this.sendSMSList[0].loadKey);
//          console.log("sendSMSList 1st inboundShipment: " + this.sendSMSList[0].inboundShipment);
//          //console.log("sendSMSList 2nd inboundShipment: " + this.sendSMSList[1].inboundShipment);
//          console.log("sendSMSList 1st driverMobile: " + this.sendSMSList[0].driverMobile);
//          //console.log("sendSMSList 2nd driverMobile: " + this.sendSMSList[1].driverMobile);
//          //console.log("in sendSMS - req1 - driver mobile: " + req1.driverMobile);
//          document.getElementById("pb").style.display = "";
         
        
//          const SMSData = api.post('/api/w/SendSMS/STCSend', { sendInfo: this.sendSMSList})
//          .then((it) => {
//             this.$store.commit('clearApiError');
//             console.log("SMS send done");
//             if (it.length > 0)
//             {
//                console.log("SMSData returns length: " + it.length);
//                //console.log("SMSDataStatus: " + it[0].status);
//                //req1.messageId = it[0].messageId;
//                //req1.inStartTime = "";
//                while (this.getLog.length > 0) {this.getLog.pop()}
//                it.forEach( (it1) => {
//                   this.smslogForm = getInitialSMSLog();
//                   this.smslogForm.loadKey = it1.loadKey;
//                   console.log("SMSData loadKey: " + it1.loadKey);
//                   console.log("inboundshipment: " + it1.containerNo);
//                   //this.smslogForm.inboundShipment = it1.inboundShipment;
//                   this.smslogForm.inboundShipment = it1.containerNo;
//                   this.smslogForm.messageId = it1.messageId;
//                   this.smslogForm.driverMobile = it1.driverMobile;
//                   this.smslogForm.containerNo = it1.containerNo;
//                   //UrlExists(it1.message);
//                   this.smslogForm.message = it1.message;
//                   this.smslogForm.shortId = it1.shortId;
//                   this.smslogForm.sendDate = "";
//                   console.log("SMSData messageId: " + it1.messageId);
//                   this.smslogForm.inStartTime = "";
//                   this.getLog.push(this.smslogForm);
//                });
//                var req2 = this.getLog;
//                if (req2)
//                {
//                   console.log("req2 length: " + req2.length);
//                   setTimeout(function() {disablebar(req2);}, (1 * 1000));
//                }
//             }
//             })
           

//            //testing purpose below
//            /*
//                while (this.getLog.length > 0) {this.getLog.pop()}
//                this.smslist.forEach( (it) => {
//                   this.smslogForm = getInitialSMSLog();
//                   this.smslogForm.inboundShipment = "200894810";
//                   this.smslogForm.messageId = "1be607cf-2e30-5d4c-997e-5ea72725e769";
//                   console.log("SMSData messageId: " + this.smslogForm.messageId);
//                   //console.log("SMSData index: " + it.indx)
//                   this.smslogForm.inStartTime = "";
//                   this.getLog.push(this.smslogForm);
//                });
//                var req2 = this.getLog;
//           setTimeout(function() {disablebar(req2);}, (1 * 1000)); 
//           */
//             $('.btn-search-master-form-driver')
//               .click();
            
//       },

    },
  };

//   function disablebar(req) {
//     console.log("to disable the bar");
//     if (req)
//     {
//        console.log("req length: " + req.length);
//        if (req.length > 0)
//        {
//           console.log("req messageId: " + req[0].messageId);
//           console.log("req loadKey: " + req[0].loadKey);
//           console.log("req inboundShipment: " + req[0].inboundShipment);
//        }
//     }
//     var statusObj = null;
//             const CheckStatus = api.post('/api/w/SendSMS/GetMsgStatus', {smsStatus: req})
//             .then((it) => {
//               console.log("it length: " + it.length);
//               if (it.length > 0)
//               {
//                  console.log("CheckStatus::messageId: " + it[0].messageId);
//                  console.log("CheckStatus::Status: " + it[0].status);
//               }
//             document.getElementById("pb").style.display = "none";
//             statusObj = document.getElementById("status");
//             console.log("statusObj: " + statusObj);
//             if (statusObj)
//             {
//                //statusObj.innerText = "Message send status: " + it[0].status;
//                statusObj.innerText = "Message sent";
//                statusObj.style.display = "";
//             }
//             if (document.getElementById("closeBtn"))
//             {
//                document.getElementById("closeBtn").click;
//             }
//             })
//   }

//   function sleep(milliseconds) {
//          const date = Date.now();
//          let currentDate = null;
//          do {
//            currentDate = Date.now();
//          } while (currentDate - date < milliseconds);
//   }

//   function utc2pst(datetimeInUTC){
//          return moment(datetimeInUTC).utc().local().format()  
//   }

//   function genWgtTicketPDFLink(inbound)
//   {
//      console.log("getWgtTicketPDFLink: " + inbound);
//      var awshost = location.host;
//      console.log("origin host: " + awshost);
//      if (awshost.includes("-dev.") || awshost.includes("localhost"))
//      {
//         return "https://named-account-web-dev.s3.us-west-2.amazonaws.com/PDF/WTicket/" + inbound + ".pdf";
//      }
//      else 
//      {
//         if (awshost.includes("-qas."))
//         {
//             return "https://named-account-web-qas.s3.us-west-2.amazonaws.com/PDF/WTicket/" + inbound + ".pdf";
//         }
//         else
//         {
//             return "https://named-account-web-prd.s3.us-west-2.amazonaws.com/PDF/WTicket/" + inbound + ".pdf";
//         }
//      }
//   }

//   function genMapLink(recwin)
//   {
//      console.log("genMapLink");
//      var awshost = location.host;
//      var fsimsg = "Hello, this is FSI Transloading Inc , please come to scale for your heavy weigh, thank you. Map: ";
//      var wilmsg = "Hello, this is FSI Wilmington Transloading Inc , please come to scale for your heavy weigh, thank you. Map: ";
//      console.log("origin host: " + awshost);
//      if (awshost.includes("-dev.") || awshost.includes("localhost"))
//      {
//         if (recwin === "185")
//            return fsimsg +
//            "https://named-account-web-dev.s3.us-west-2.amazonaws.com/upload_images/FSI_MAP/FSI.jpg";
//         else
//            return wilmsg +
//            "https://named-account-web-dev.s3.us-west-2.amazonaws.com/upload_images/WIL_MAP/Wilmington.jpg";
//      }
//      else 
//      {
//         if (awshost.includes("-qas."))
//         {
//             if (recwin === "185")
//                return fsimsg + "https://named-account-web-qas.s3.us-west-2.amazonaws.com/upload_images/FSI_MAP/FSI.jpg";
//             else
//                return wilmsg + "https://named-account-web-qas.s3.us-west-2.amazonaws.com/upload_images/WIL_MAP/Wilmington.jpg";
//         }
//         else
//         {
//             if (recwin === "185")
//                return fsimsg + "https://named-account-web-prd.s3.us-west-2.amazonaws.com/upload_images/FSI_MAP/FSI.jpg";
//             else
//                return wilmsg + "https://named-account-web-prd.s3.us-west-2.amazonaws.com/upload_images/WIL_MAP/Wilmington.jpg";
//         }
//      }
//   }


//   function UrlExists(url) {
//      console.log("call UrlExists");
//      fetch(url)
//      .then(async response => {
//         const data = await response.json();
//         if (!response.ok) {
//            const error = (data && data.message) || response.statusText;
//            return Promise.reject(error);
//         }
//         this.totalVuePackages = data.total;
//         console.log("totalVuePackages: " + this.totalVuePackages);
//      }
//      )
//      .catch (error => {
//         this.errorMessage = error;
//         console.error("There was an error!", error);
//      })
//   }
</script>